export default __webpack_public_path__ + "static/media/IIHCP.70a5897e.jpg";